/**
 * 预加载所有图片（首页 + 弹框）
 * @returns {Promise} 所有图片加载完成的 Promise
 */
export function preloadAllImages() {
  const imageList = [
    // ========== 首页图片 ==========
    // 背景图
    require('@/assets/imgs/xibNewCustomerGift/luyuanBg.png'),
    // 权益等级图片
    `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerWx&4104&20260701095807.png`,
    `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJd&8113&20260701095838.png`,
    `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJf&11049&20260701095855.png`,
    `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerBl&2500&20260701095912.png`,
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw7&18932&20260701150532.png', 
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw8&11384&20260701150536.png', 
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw5&9362&20260701150523.png', 
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw6&3993&20260701150527.png', 
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw3&9573&20260701150514.png', 
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw4&10675&20260701150518.png', 
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw1&14154&20260701150505.png', 
    'https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw2&5393&20260701150510.png',


    // 领取按钮
    require('@/assets/imgs/xibNewCustomerGift/luyuanSignUpBtnBg1.png'),
    // 规则图片
    require('@/assets/imgs/xibNewCustomerGift/ruleTable.png'),
    
    
    // 功能按钮（规则、记录）
    require('@/assets/imgs/xibNewCustomerGift/luyuanRuleBg.png'),
    require('@/assets/imgs/xibNewCustomerGift/luyuanRecordBg.png'),

    // ========== 领取弹框图片 ==========
    require('@/assets/imgs/xibNewCustomerGift/luyuanRecordModalBg.png'),
    require('@/assets/imgs/xibNewCustomerGift/rewardBtn.png'),
    require('@/assets/imgs/xibNewCustomerGift/rewardWxBg.png'),
    require('@/assets/imgs/xibMaintain/record-modal-close.png'),
    // ========== 弹框共用资源 ==========
    require('@/assets/imgs/xibNewCustomerGift/luyuanModalTitleBg.png'),
    require('@/assets/imgs/xibNewCustomerGift/luyuanStarFx.png'),
    // ========== 二次确认弹框 ==========
    require('@/assets/imgs/xibNewCustomerGift/luyuanConfirmBtns.png'),
    // ========== 选择奖品弹框 ==========
    require('@/assets/imgs/xibNewCustomerGift/luyuanRewardStarFx.png'),
    require('@/assets/imgs/xibNewCustomerGift/luyuanRewardSoldOut.png'),
    require('@/assets/imgs/xibNewCustomerGift/luyuanRewardCheckNew.png'),
    require('@/assets/imgs/xibNewCustomerGift/luyuanRewardExclusiveTag.png'),
    require('@/assets/imgs/xibNewCustomerGift/luyuanRewardConfirmBtns.png'),
    // ========== 提示消息弹框 ==========
    require('@/assets/imgs/xibNewCustomerGift/luyuanTipKnowBtns.png'),
  ]

  // 预加载所有图片
  const promises = imageList.map(src => {
    return new Promise((resolve) => {
      const img = new Image()
      img.onload = () => {
        // console.log('✅ 图片加载成功:', src.split('/').pop())
        resolve(src)
      }
      img.onerror = () => {
        // console.warn('❌ 图片加载失败:', src.split('/').pop())
        resolve(src) // 失败也继续，避免阻塞
      }
      img.src = src
    })
  })

  return Promise.all(promises)
}